import * as React from 'react';

import { useTranslations } from '../../../i18n/useTranslations';

type PhotoWarningBannerProps = {
  hasBooking: boolean;
  photoUploadStatus: 'complete' | 'partial' | 'incomplete';
};

export const PhotoWarningBanner: React.FC<PhotoWarningBannerProps> = ({
  hasBooking,
  photoUploadStatus,
}) => {
  const t = useTranslations();

  if (!hasBooking || photoUploadStatus !== 'incomplete') {
    return null;
  }

  return (
    <div className="@PhotoWarningBanner sticky top-0 z-10 bg-white pt-5">
      <div className="z-10 flex min-h-[54px] items-center justify-center rounded-md border border-warning/40 bg-warning/10 px-4 text-center text-sm text-warning-darker">
        <span className="font-semibold">
          {t.loadDetail.photos.warning.required}
        </span>
        <span className="ml-1">{t.loadDetail.photos.warning.toShip}</span>
      </div>
    </div>
  );
};
